import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getSwitchOrganizationUseCase } from "@/hooks/useDi";
import { resetAllFilterStores } from "@/stores/useResetAllFilterStore";

export const useSwitchOrganization = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (organizationId: string | number) => {
			const result = await getSwitchOrganizationUseCase().execute(
				String(organizationId),
			);
			if (!result.success) throw new Error(result.error);
			return { organizationId };
		},
		onSuccess: () => {
			// TQ cache invalidation (React-specific — stays in hook)
			queryClient.invalidateQueries({
				predicate: (query) => {
					const key = query.queryKey;
					const nonOrgScoped = ["hub", "proposals", "userProfile", "admin"];
					if (typeof key[0] === "string" && nonOrgScoped.includes(key[0]))
						return false;
					return true;
				},
			});
			resetAllFilterStores();
		},
	});
};
